import React from 'react';

export default function InputRequired(props) {
  return (<span>{props.name} <span className="color-required">*</span></span>)
}
